module.exports = __webpack_public_path__ + "static/media/BrochureGlobrite.b34dca7b.pdf";